import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CacheManager from '../../../cache/CacheManager';
import CacheKeys from '../../../cache/CacheKeys';
import NachFailureRecordsPageUI from './NachFailureRecordsPageUI';

class NachFailureRecordsPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorList: null,
      nachFailureList: null,
      account: null,
      yearMonth: null,
      updateMode: false,
    };
  }
  render() {
    return (
      <NachFailureRecordsPageUI
        context={this.props.context}
        account={this.state.account}
        nachFailureList={this.state.nachFailureList}
        errorList={this.state.errorList}
        onRefreshClick={this.onRefreshClick}
        yearMonth={this.state.yearMonth}
        onPreviousClick={this.onPreviousClick}
        onNextClick={this.onNextClick}
        //
        onUpdateClick={() => { this.setState({ updateMode: true }) }}
        updateMode={this.state.updateMode}
        onCancelClick={() => { this.setState({ updateMode: false }) }}
      />
    );
  }

  componentDidMount() {
    this.getAccount(this.props.context);
    this.getNachFailureRecords(this.props.context, '', '');
  }

  getAccount(context) {
    const { accountId } = this.props.match.params;

    const cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Accounts(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600,
    });

    cacheManager.getObject2(context);
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account });
  };

  getNachFailureRecords(context, year, month) {
    const { accountId } = this.props.match.params;
    year = year === undefined ? '' : year
    month = month === undefined ? '' : month

    const cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}/nachFailures`,
      cacheKey: CacheKeys.NachFailures(accountId, year, month),
      callback: this.getNachFailureRecordsCallBack,
      ttlInSecs: 600,
    });

    cacheManager.getObject2(context, {}, { year: year, month: month });
  }

  getNachFailureRecordsCallBack = (response) => {
    this.setState({
      nachFailureList: response.nachFailureList,
      errorList: response.errorList,
      yearMonth: response.yearMonth,
      year: response.yearMonth.year,
      month: response.yearMonth.month,
      previousYear: response.yearMonth.prevYear,
      previousMonth: response.yearMonth.prevMonth,
      nextYear: response.yearMonth.nextYear,
      nextMonth: response.yearMonth.nextMonth
    });
  };

  onPreviousClick = () => {
    let context = this.props.context
    this.getNachFailureRecords(context, this.state.previousYear, this.state.previousMonth)
  }

  onNextClick = () => {
    let context = this.props.context
    this.getNachFailureRecords(context, this.state.nextYear, this.state.nextMonth)
  }

  onRefreshClick = () => {
    const { accountId } = this.props.match.params;
    CacheManager.removeObject(CacheKeys.NachFailures(accountId, this.state.year, this.state.month));
    this.setState({ nachFailureList: null, errorList: null });
    this.getNachFailureRecords(this.props.context, this.state.year, this.state.month);
  };
}

export default withRouter(NachFailureRecordsPageSF);
